<template>
  <div>
    <ul class="target-groups">
      <li 
        v-for="(tg, index) in groups" :key="index" 
        class="target-group-tile rounded"
        :class="{selected: selected == tg}"
        @click="selectTile(index)">
        <i class="material-icons">person</i>
        {{tg}}
      </li>
    </ul>
    
    
  </div>
</template>

<script>
  export default {
    name: "SelectTargetGroup",
    props: {
      group: {
        type: String,
        default: null
      },
    },
    data () {
      return {
        selected: null,
        groups: [
          "Club Safety Officers",
          "Fan Representatives",
          "National Associations",
          "NFIP",
          "Police Commanders",
          "Police Spotters",
          "Private Security",
          "Stadium director/manager",
          "Stadium Executives",
          "Stadium owner",
          "Stadium Safety Manager",
          "Stewards",
          "Training Companies",
          "Club Licensing",
          "Match Delegates",
          "Security Officers",
          "Stadium Inspectors"
        ]
      }
    },
    methods: {
      selectTile(index) {
        this.selected = this.groups[index]
        this.$emit('input', this.groups[index])
      }
    },
    mounted () {
      this.selected = this.group
    },
  }


</script>

<style lang="scss" scoped>
.target-groups {
  margin: 0 0 15px;
  padding: 0;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 15px;
  row-gap: 15px;

  @media all and (min-width: 700px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media all and (min-width: 1100px) {
    grid-template-columns: repeat(4, 1fr);
  }
  

  li {
    flex: 1;
    // min-width: 125px;
    // max-width: 250px;
    // min-height: 100px;
    

    @media all and (min-width: 768px) {
      // min-width: 180px;
    }
  }
}
.target-group-tile {
  background-color: #E2E8FF;
  color: #3D3DDE;
  // margin: 10px 10px;
  padding: 12px 15px;
  font-size: 14px;
  cursor: pointer;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  i {
    font-size: 44px;
  }

  &.selected {
    color: #E2E8FF;
    background-color: #3D3DDE;
  }
}
</style>